import { Button, Col, Row, Spinner } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import RHFSelectWithInvalid from "../../../../rhf/rhfselectwithinvalid";
import { ReplaceNullsWithEmptyStrings } from "../../../../utilities/rhfdatanormalizationfunctions";
import { useIncidentFollowupStaffUpsert } from "../../../../new/query";
import useMessageStore from "../../../../stores/message-store";
import { yupResolver } from "@hookform/resolvers/yup";
import FormInputValidationMessage from "../../../../components/forminputvalidationmessage";
import { buildIncidentFollowupStaffValidationSchema } from "./incident-validation";
import IncidentErrorAlert from "./incidenterroralert";
import { normalizeIncidentFollowupStaffPayload } from "./incident-payload";

const IncidentAssignStaffNew = ({values,defintions,medicaidid,hashkey,incidentid,onCreated = null}) => {
    const initialValues = {
        staffAssignment: '',
        followupType: '',
        areasToCheck: [],
        incidentResponseDueDate: '',
        incidentResponseComments: '',
        fieldStaffResponseDate: '',
        fieldStaffResponseComments: ''
    }

    const _mergeData = (data) => {
        const {areasToCheck,...rest} = data;

        const selectedMap = new Map(
            areasToCheck.map(i => [i.areaToCheck,i]) ?? []
        );

        const rows = defintions.areastocheck.map(t => {
            const sel = selectedMap.get(t.id);
            return{
                typeId: t.id,
                name: t.name,
                checked: !!sel,
                comment: sel?.comments ?? '',
                existingId: sel?.id ?? null
            }
        })

        const preparedRest = ReplaceNullsWithEmptyStrings(rest);

        return{
            ...preparedRest,
            staffAssignment: preparedRest.staffAssignment !== '' ? `${preparedRest.staffAssignment}` : '',
            areasToCheck: rows
        }
    }

    const fixDataToSend = (data) => {
        const {areasToCheck,...rest} = data; //Extract ATC

        const atc = areasToCheck.filter(r => r.checked)
            .map(r => ({
                id: r.existingId ?? crypto.randomUUID(),
                areaToCheck: r.typeId,
                comments: r.comment
            }))

        return{
            ...rest,
            areasToCheck: atc
        }
    }

    const addToast = useMessageStore(state => state.addToast);

    const submittedCallback = (data) => {
        if(values === null){
            onCreated();
        }
        else{
            const {followupStaff} = data;
            console.log(followupStaff);
            
            const finalObj = _mergeData(followupStaff);

            console.log(finalObj);

            methods.reset(finalObj);
            

        } 

        addToast(
            {
                id: Math.random(),
                body: "The Followup Staff was succesfully saved!",
                autoHide: true,
                errorFlag: false,
                timestamp: Date.now() - 1000
            }
        )
    }

    const mutation = useIncidentFollowupStaffUpsert(incidentid,medicaidid,submittedCallback);

    const _submitFn = (data) => {
        const sendObj = fixDataToSend(data);
        mutation.mutate(normalizeIncidentFollowupStaffPayload(sendObj, incidentid));
    }

    const methods = useForm({
        defaultValues: values === null ? _mergeData(initialValues) : _mergeData(values),
        resolver: yupResolver(buildIncidentFollowupStaffValidationSchema(defintions))
    });

    const areasToCheck = methods.watch('areasToCheck');
    // const {register,reset,control,handleSubmit, formState: {isDirty}} = methods;
    return(
        <form onSubmit={methods.handleSubmit(_submitFn)}>
            <div style={{backgroundColor: 'rgb(219,219,219)',border: '1px dashed black', padding: '4px'}}>
                <Row>
                    <Col xs={12} md={6}>
                        <RHFSelectWithInvalid
                            name='staffAssignment'
                            label='Staff Assignment'
                            methods={methods}
                            refinedOptions={defintions.sttrttusers}
                            masterOptions={defintions.usermasterlist}
                            placeholder="--Select User--"
                            style={{width: '100%'}}
                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <label htmlFor="followupType">Followup Type</label>
                        <select id="followupType" {...methods.register('followupType')} style={{width: '100%'}}>
                            <option value=''>--Select Followup Type--</option>
                            {
                                defintions.followuptype.map((ft) => (
                                    <option key={ft.id} value={ft.id}>{ft.name}</option>
                                ))
                            }
                        </select>
                        <FormInputValidationMessage error={methods.formState.errors.followupType} />
                    </Col>
                </Row>
                <Row className="mt-2">
                    {
                        areasToCheck.map((row,idx) => (
                            <Controller
                                key={row.typeId}
                                name={`areasToCheck.${idx}`}
                                control={methods.control}
                                render={({field}) => {
                                    const {value,onChange} = field;
                                    
                                    return(
                                        <Col xs={12}>
                                            <label>
                                                <input 
                                                    type="checkbox"
                                                    checked={value.checked}
                                                    onChange={(e) => onChange({...value,checked: e.target.checked})}
                                                />
                                                {value.name}
                                            </label>
                                            <textarea style={{width:'100%'}} rows={4} value={value.comment} disabled={!value.checked}
                                                onChange={(e) => onChange({...value,comment: e.target.value})}
                                            />
                                        </Col>
                                    )
                                }}
                            />
                        ))
                    }
                </Row>
                <Row className="mt-2">
                    <Col xs={12}>
                        <div>
                            <label htmlFor="incidentResponseDueDate">Incident Response Due Date</label>
                        </div>
                        <input id="incidentResponseDueDate" type="date" {...methods.register('incidentResponseDueDate')} />
                    </Col>
                    <Col xs={12}>
                        <label htmlFor="incidentResponseComments">Incident Response Comments</label>
                        <textarea id="incidentResponseComments" {...methods.register('incidentResponseComments')} style={{width: '100%'}} rows={4} />
                    </Col>
                    <Col xs={12}>
                        <div>
                            <label htmlFor="fieldStaffResponseDate">Field Staff Response Due Date</label>
                        </div>
                        <input id="fieldStaffResponseDate" type="date" {...methods.register('fieldStaffResponseDate')} />
                    </Col>
                    <Col xs={12}>
                        <label htmlFor="fieldStaffResponseComments">Field Staff Response Comments</label>
                        <textarea id="fieldStaffResponseComments" {...methods.register('fieldStaffResponseComments')} style={{width: '100%'}} rows={4} />
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xs={12}>
                        <IncidentErrorAlert
                            error={mutation.error}
                            fallbackMessage="The follow-up staff assignment could not be saved."
                            className="mb-3"
                        />
                        <div className="d-flex justify-content-end">
                            <Button type="submit" variant={values ? "primary" : 'success'} disabled={mutation.isPending || (values ? !methods.formState.isDirty : false)}>
                                {
                                    mutation.isPending
                                    ?
                                        <Spinner animation='border' size='sm' />
                                    :
                                        values
                                        ?
                                            <>Save Changes</>
                                        :
                                            <>Add Followup</>
                                }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </form>
    )
}

export default IncidentAssignStaffNew;
